import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { v4 as uuid } from "uuid"
import moment from "moment";

import "../index.css"
import { Button, TextInputField, DropDownField, CalendarField, MultiSelectField } from "../../../helpers"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"

const SmartScheduler = (props) => {
    const { handleCustomScheduler, setIsSmartSchedulerVisible, setDatewisePOSchedule, setDatewisePOScheduleItems, buyerPOItems } = props
    const dispatch = useDispatch()

    const [scheduleType, setScheduleType] = useState("smart")
    const [recurrence, setRecurrence] = useState('')
    const [startDate, setStartDate] = useState(new Date())
    const [dayOfWeek, setDayOfWeek] = useState('')
    const [selectedDates, setSelectedDates] = useState([])
    const [numberOfInstances, setNumberOfInstances] = useState('')
    const [endDate, setEndDate] = useState(null)
    const [poMode, setPoMode] = useState('limited')
    const [inputQuantities, setInputQuantities] = useState([])

    const recurrenceOptions = [
        { label: 'Weekly', value: 'weekly' },
        { label: 'Bi-weekly', value: 'bi-weekly' },
        { label: 'Monthly', value: 'monthly' }
    ]

    const poModeOptions = [
        { label: 'Limited PO', value: 'limited' },
        { label: 'Unlimited PO', value: 'unlimited' }
    ]

    const dayOptions = [
        { label: 'Sunday', value: 0 },
        { label: 'Monday', value: 1 },
        { label: 'Tuesday', value: 2 },
        { label: 'Wednesday', value: 3 },
        { label: 'Thursday', value: 4 },
        { label: 'Friday', value: 5 },
        { label: 'Saturday', value: 6 },
    ]

    const dateOptions = Array.from({ length: 31 }, (_, index) => ({ label: `${index + 1}`, value: index + 1 }))

    /*useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            console.log("entered 33")
            if (endDate && !numberOfInstances) {
                setNumberOfInstances(calculateOccurrencesFromEndDate())
            } else if (numberOfInstances && !endDate) {
                setEndDate(calculateEndDateFromOccurrences())
            }
        }, 300)

        return () => clearTimeout(delayDebounceFn)
    }, [endDate, numberOfInstances])

    useEffect(() => {
        if (endDate && startDate && recurrence) {
            console.log("entered 11")
            const calculatedOccurrences = calculateOccurrencesFromEndDate()
            if (calculatedOccurrences !== numberOfInstances) {
                setNumberOfInstances(calculatedOccurrences)
            }
        }
    }, [endDate, startDate, recurrence, dayOfWeek, selectedDates])

    useEffect(() => {
        if (numberOfInstances && startDate && recurrence) {
            console.log("entered 22")
            const calculatedEndDate = calculateEndDateFromOccurrences()
            if (calculatedEndDate.getTime() !== new Date(endDate).getTime()) {
                setEndDate(calculatedEndDate)
            }
        }
    }, [numberOfInstances, startDate, recurrence, dayOfWeek, selectedDates])*/

    useEffect(() => {
        resetSchedulerFields()
    }, [startDate, dayOfWeek, recurrence])

    useEffect(() => {
        if (poMode === 'unlimited' && buyerPOItems) {
            setInputQuantities(buyerPOItems.map(() => ''))
        }
    }, [poMode, buyerPOItems])

    const handleOccurences = (value) => {
        value = parseInt(value)
        if (startDate && recurrence) {
            setNumberOfInstances(value)
            const calculatedEndDate = calculateEndDateFromOccurrences(value)
            if (calculatedEndDate.getTime() !== new Date(endDate).getTime()) {
                setEndDate(calculatedEndDate)
            }
        }
    }

    const handleEndDate = (date) => {
        if (date && startDate && recurrence) {
            setEndDate(date)
            const calculatedOccurrences = calculateOccurrencesFromEndDate(date)
            if (calculatedOccurrences !== numberOfInstances) {
                setNumberOfInstances(calculatedOccurrences)
            }
        }
    }

    const handleScheduleTypeChange = (e) => {
        if(e.target.value === 'custom'){
            handleCustomScheduler()
            setIsSmartSchedulerVisible(false)
        }
        setScheduleType(e.target.value)
        resetSchedulerFields()
    }

    const handleRecurrenceChange = (e) => {
        setRecurrence(e.target.value)
        resetSchedulerFields()
    }

    const resetSchedulerFields = () => {
        setNumberOfInstances('')
        setEndDate('')
    }

    const calculateOccurrencesFromEndDate = (date) => {
        let occurrences = 0
        let currentDate = startDate
        const finalEndDate = date

        let isFirstOccurrence = true
        while (currentDate <= finalEndDate) {
            currentDate = getNextRecurrenceDate(currentDate, recurrence, isFirstOccurrence)
            isFirstOccurrence = false

            if (moment(currentDate).isSameOrBefore(moment(finalEndDate), 'day')) {
                occurrences++
            }
        }
        return occurrences
    }

    const getNextRecurrenceDate = (currentDate, recurrenceType, isFirstOccurrence = false) => {
        const date = new Date(currentDate)

        switch (recurrenceType) {
            case 'weekly':
                const daysUntilNext = (dayOfWeek - date.getDay() + 7) % 7
                if (isFirstOccurrence && daysUntilNext === 0) {
                    return date
                } else {
                    date.setDate(date.getDate() + (daysUntilNext === 0 ? 7 : daysUntilNext))
                }
                break

            case 'bi-weekly':
                const daysUntilNextBiWeekly = (dayOfWeek - date.getDay() + 7) % 7
                if (isFirstOccurrence) {
                    date.setDate(date.getDate() + (daysUntilNextBiWeekly === 0 ? 0 : daysUntilNextBiWeekly))
                } else {
                    date.setDate(date.getDate() + 14)
                }
                break

            case 'monthly':
                if (selectedDates.length > 0) {
                    const sortedSelectedDates = selectedDates.sort((a, b) => a - b)
                    const currentDay = date.getDate()

                    if (isFirstOccurrence) {
                        const matchingStartDate = sortedSelectedDates.includes(currentDay)

                        if (matchingStartDate) {
                            date.setDate(currentDay)
                        } else {
                            const upcomingDateInMonth = sortedSelectedDates.find(selectedDate => selectedDate > currentDay)

                            if (upcomingDateInMonth) {
                                date.setDate(upcomingDateInMonth)
                            } else {
                                date.setMonth(date.getMonth() + 1)
                                date.setDate(sortedSelectedDates[0])
                            }
                        }
                    } else {
                        const nextDateInMonth = sortedSelectedDates.find(selectedDate => selectedDate > currentDay)

                        if (nextDateInMonth) {
                            date.setDate(nextDateInMonth)
                        } else {
                            date.setMonth(date.getMonth() + 1)
                            date.setDate(sortedSelectedDates[0])
                        }
                    }
                } else {
                    date.setMonth(date.getMonth() + 1)
                }
                break

            default:
                break
        }

        return date
    }

    const calculateEndDateFromOccurrences = (value) => {
        let currentDate = new Date(startDate)

        let isFirstOccurrence = true
        for (let i = 0; i < value; i++) {
            currentDate = getNextRecurrenceDate(currentDate, recurrence, isFirstOccurrence)
            isFirstOccurrence = false
        }
        return currentDate
    }

    const handleLimitedPOScheduler = () => {
        let currentDate = new Date(startDate)
        let totalOccurrences = numberOfInstances

        if (!totalOccurrences && endDate) {
            totalOccurrences = calculateOccurrencesFromEndDate(endDate)
            setNumberOfInstances(totalOccurrences)
        } else if (numberOfInstances && !endDate) {
            setEndDate(calculateEndDateFromOccurrences(numberOfInstances))
        }

        if (totalOccurrences === 0) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Cannot proceed with zero occurrences', life: 3000 }))
        }

        let remainingInstances = totalOccurrences
        const tempBuyerPOItems = buyerPOItems.map(item => item.bPOQty)

        let isFirstOccurrence = true

        for (let i = 0; i < totalOccurrences; i++) {
            const scheduledDate = getNextRecurrenceDate(currentDate, recurrence, isFirstOccurrence)
            currentDate = new Date(scheduledDate)
            isFirstOccurrence = false

            const datewiseSchedule = {
                columnId: uuid(),
                isNew: true,
                scheduledDate: scheduledDate
            }

            setDatewisePOSchedule(prevState => [...prevState, datewiseSchedule])

            buyerPOItems.forEach((eachBuyerPOItem, index) => {
                let remainingQty = tempBuyerPOItems[index]
                let dividedQuantity = Math.floor(remainingQty / remainingInstances)

                if (dividedQuantity === 0 && remainingQty > 0) {
                    dividedQuantity = 1
                }

                tempBuyerPOItems[index] -= dividedQuantity

                const datewiseScheduleItem = {
                    ...eachBuyerPOItem,
                    columnItemId: uuid(),
                    columnId: datewiseSchedule.columnId,
                    scheduledQty: dividedQuantity,
                    isNew: true
                }

                setDatewisePOScheduleItems(prevState => [...prevState, datewiseScheduleItem])
            })

            remainingInstances -= 1
        }

        //dispatch(raiseToast({ severity: 'success', detail: 'Schedules created successfully', life: 3000 }))
    }

    const handleUnlimitedPOScheduler = () => {
        const totalOccurrences = numberOfInstances || calculateOccurrencesFromEndDate(endDate)
        let currentDate = new Date(startDate)
        let isFirstOccurrence = true
    
        const remainingQtyForItems = buyerPOItems.map(item => item.bPOQty)
        let i = 0
    
        while (i < totalOccurrences) {
            let scheduledDate
            if (i === totalOccurrences - 1) {
                if(totalOccurrences === 1){
                    scheduledDate = getNextRecurrenceDate(currentDate, recurrence, isFirstOccurrence)
                }else{
                    scheduledDate = new Date("2099-12-31")
                }
            } else {
                scheduledDate = getNextRecurrenceDate(currentDate, recurrence, isFirstOccurrence)
            }
            currentDate = new Date(scheduledDate)
            isFirstOccurrence = false

            const datewiseSchedule = {
                columnId: uuid(),
                isNew: true,
                scheduledDate: scheduledDate
            }

            setDatewisePOSchedule(prevState => [...prevState, datewiseSchedule])

            buyerPOItems.forEach((eachBuyerPOItem, index) => {
                const inputQty = parseInt(inputQuantities[index]) || 0
                let dividedQuantity

                if (inputQty === 0 || isNaN(inputQty)) {
                    if (i === 0) {
                        dividedQuantity = remainingQtyForItems[index]
                        remainingQtyForItems[index] = 0
                    } else {
                        dividedQuantity = 0
                    }
                } else {
                    if (remainingQtyForItems[index] > 0) {
                        dividedQuantity = i < totalOccurrences - 1
                            ? Math.min(inputQty, remainingQtyForItems[index])
                            : remainingQtyForItems[index]
                        remainingQtyForItems[index] -= dividedQuantity
                    } else {
                        dividedQuantity = 0
                    }
                }

                const datewiseScheduleItem = {
                    ...eachBuyerPOItem,
                    columnItemId: uuid(),
                    columnId: datewiseSchedule.columnId,
                    scheduledQty: dividedQuantity,
                    isNew: true
                }
                setDatewisePOScheduleItems(prevState => [...prevState, datewiseScheduleItem])
            })
            i++
        }

        //dispatch(raiseToast({ severity: 'success', detail: 'Schedules created successfully', life: 3000 }))
    }

    const handleSmartScheduler = () => {
        if (poMode === 'limited') {
            handleLimitedPOScheduler()
        } else if (poMode === 'unlimited') {
            handleUnlimitedPOScheduler()
        }
    }

    const handleQuantityChange = (index, item, value) => {
        const availableQty = item.bPOQty
        const enteredValue = parseInt(value)
        const newValue = enteredValue > availableQty ? availableQty : enteredValue
    
        const newQuantities = [...inputQuantities]
        newQuantities[index] = newValue
        setInputQuantities(newQuantities)
    }

    const handleContinue = () => {
        if (scheduleType === "smart") {
            if (!recurrence) {
                return dispatch(raiseToast({ severity: 'error', detail: 'Please select recurrence type', life: 3000 }))
            }

            if (!startDate || !endDate || (['weekly', 'bi-weekly'].includes(recurrence) && (dayOfWeek === null || dayOfWeek === undefined)) || (recurrence === 'monthly' && selectedDates.length === 0)) {
                return dispatch(raiseToast({ severity: 'error', detail: 'Please fill in all required fields', life: 3000 }))
            }

            if (!numberOfInstances) {
                return dispatch(raiseToast({ severity: 'error', detail: "Can't proceed with 0 occurances", life: 3000 }))
            }

            if (numberOfInstances === 0) {
                return dispatch(raiseToast({ severity: 'error', detail: 'Cannot proceed with zero occurrences', life: 3000 }))
            }
            const confirmMsg = inputQuantities.some(qty =>  qty === 0  || qty === null || qty === '' || isNaN(qty))
            ? "Scheduling with 0 Schedule Qty, are you sure to continue?" 
            : "Are you sure to continue?"
        
            if(window.confirm(confirmMsg)){
                setIsSmartSchedulerVisible(false)
                handleSmartScheduler()
            }else{
                setIsSmartSchedulerVisible(true)
            }
        } else {
            setIsSmartSchedulerVisible(false)
            handleCustomScheduler()
        }
    }

    return (
        <div className="smart-scheduler-container flex flex-column pb-2 mt-3">
            <div className="flex mb-3">
                <label className="mr-3">
                    <input type="radio" value="smart" checked={scheduleType === "smart"} onChange={handleScheduleTypeChange} />
                    <span className="ml-1">Smart Scheduler</span>
                </label>
                <label>
                    <input type="radio" value="custom" checked={scheduleType === "custom"} onChange={handleScheduleTypeChange} />
                    <span className="ml-1">Custom Schedule</span>
                </label>
            </div>

            {scheduleType === "smart" && (
                <>
                    <div className="flex flex-row">
                        <div className="flex flex-column col-12 lg:col-12 lg:mb-0">

                            <DropDownField labelText="Recurrence" value={recurrence} options={recurrenceOptions} onChange={handleRecurrenceChange} required />
                        </div>
                    </div>

                    {['weekly', 'bi-weekly'].includes(recurrence) && (
                        <div className="flex flex-row mt-2">
                            <div className="flex flex-column col-12 lg:col-6 lg:mb-0">
                                <CalendarField labelText="Start Date" minDate={new Date()} value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
                            </div>
                            <div className="flex flex-column col-12 lg:col-6 lg:mb-0">
                                <DropDownField labelText="Select Day of Week" value={dayOfWeek} options={dayOptions} onChange={(e) => setDayOfWeek(e.target.value)} required />
                            </div>
                        </div>
                    )}

                    {recurrence === 'monthly' && (
                        <div className="flex flex-row mt-2">
                            <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                                <CalendarField labelText="Start Date" minDate={new Date()} value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
                            </div>
                            <div className="flex flex-column col-12 lg:col-8 lg:mb-0">
                                <MultiSelectField labelText="Select Dates" value={selectedDates} options={dateOptions} onChange={(e) => setSelectedDates(e.target.value)} required />
                            </div>
                        </div>
                    )}

                    {startDate && ((dayOfWeek !== null && dayOfWeek !== '') || selectedDates.length > 0) && (
                        <div className="flex flex-row mt-3">
                            <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                                <TextInputField labelText="Occurrences" inputStyle={{ width: "100%" }} value={numberOfInstances} keyfilter="num" onChange={(e) => handleOccurences(e.target.value)} required />
                            </div>
                            <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                                <CalendarField labelText="End Date" value={endDate} minDate={startDate} onChange={(e) => handleEndDate(new Date(e.value))} required />
                            </div>
                            <div className="flex flex-column col-12 lg:col-5 lg:mb-0">
                                <DropDownField labelText="PO Mode" value={poMode} options={poModeOptions} onChange={(e) => setPoMode(e.target.value)} required />
                            </div>
                        </div>
                    )}

                    {poMode === 'unlimited' && (
                        <div className="mt-3">
                            <h5>Please Enter Qty For Regular Schedule:</h5>
                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>Material Id</th>
                                        <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Ava. Qty</th>
                                        <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Schedule Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {buyerPOItems.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{item.materialId}</td>
                                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{item.bPOQty}</td>
                                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                                <TextInputField
                                                    keyfilter="num"
                                                    inputStyle={{ width: "100px" }}
                                                    value={inputQuantities[index]}
                                                    onChange={(e) => handleQuantityChange(index, item, e.target.value)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}

            <div className="flex flex-row mt-2 justify-content-center mt-5 m-0">
                {scheduleType === 'smart' &&
                    <Button label="Continue" onClick={handleContinue} />
                }
            </div>
        </div>
    )
}

export default SmartScheduler
